import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import { useGoToQuote } from "../hooks/useGoToQuote";
export function ComingSoon() {
  const goToQuote = useGoToQuote();
  return <section className="mx-auto flex min-h-[70vh] max-w-3xl flex-col justify-center px-5 pb-24 pt-40 md:px-10" data-id="element-326" data-mp="4bd92lrw4mq7">
      <h1 className="font-display text-5xl leading-tight text-ink md:text-6xl" data-id="element-327" data-mp="3vfaby06xbv5r">Cette page est en préparation.</h1>
      <p className="mt-6 max-w-xl text-lg leading-relaxed text-stone" data-id="element-328" data-mp="d95p5s5fryen">
        Nous finalisons ce contenu. En attendant, notre équipe commerciale répond à toutes vos questions sous
        48 h ouvrées.
      </p>
      <div className="mt-10 flex flex-wrap gap-3" data-id="element-329" data-mp="n2w8yjqmbko0">
        <button type="button" onClick={goToQuote} className="h-12 rounded-full bg-terracotta px-6 text-sm font-medium text-paper hover:bg-terracotta-dark" data-id="element-330" data-mp="i306wq1he3b3">
          Demander un devis
        </button>
        <Link to="/" className="flex h-12 items-center gap-2 rounded-full border border-line px-6 text-sm text-ink hover:bg-cream" data-id="element-331" data-mp="ry1xlqbendfs">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-332" data-mp="125w4mkzedz6x" /> Retour à l'accueil
        </Link>
      </div>
    </section>;
}